export type IInitReCaptchaFields = IDCA.IGenericFunc;

function setupReCaptchaScript(): Promise<void> {
  return new Promise<void>((resolve, reject) => {
    if (window.grecaptcha) {
      return resolve();
    }
    $.getScript(`https://www.google.com/recaptcha/api.js?render=explicit`).then(
      () => {
        resolve();
      },
      () => {
        reject();
      }
    );
  });
}

export async function _initReCaptchaFields(): Promise<void> {
  const $div = $('.g-recaptcha.g-recaptcha-invisible').first();

  if (!Boolean($div.length)) return;

  const $fieldHolder = $div.closest('.field-holder');
  const $input = $fieldHolder.find('.g-recaptcha-invisible-input');
  if (!$input.length) return;
  const input = $input.get(0);

  await setupReCaptchaScript();

  DCA._validateReCaptchaFields($input.val(), input, true);
}
